<template>
  <v-container fill-height fluid style="height: 100%; padding: 0;">
    <v-layout fill-height row wrap style="height: 100%">
      <AdminSideBarMenu />
      <v-flex class="dashboard-view">
        <v-breadcrumbs>
          <v-breadcrumbs-item :disabled="true">Admin</v-breadcrumbs-item>
          <v-breadcrumbs-item :disabled="true">Access</v-breadcrumbs-item>
        </v-breadcrumbs>
        <v-card class="bordered-card" style="height: 100%;">
          <v-toolbar class="grey lighten-4 elevation-0">
            <v-toolbar-title class="grey--text text-underline text--darken-4">
              Manage Access
            </v-toolbar-title>
          </v-toolbar>
          <v-list three-line subheader>
            <v-list-tile class="title-toolbar">
              <v-flex xs4>
                <v-select
                  v-bind:items="roles"
                  v-model="currentRole"
                  label="Select"
                  class="input-group--focused"
                  single-line
                  hint="Select a Role"
                  persistent-hint
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-dialog v-model="open_modal" lazy absolute max-width="790px">
                  <v-btn
                  slot="activator"
                  dark color="primary">
                    <v-icon dark>add</v-icon> Add role
                  </v-btn>
                  <NewRole :activeDialog="activeDialog" :length="length" />
                </v-dialog>
                <v-dialog max-width="790px" :fullscreen="screenWidth < 768" v-if="currentRole !== 0" v-model="dialog" lazy absolute>
                  <v-btn slot="activator" dark color="red">
                    <v-icon dark>delete</v-icon> Delete role
                  </v-btn>
                  <v-card>
                    <v-card-title>
                      <div class="center headline">Confirm delete</div>
                    </v-card-title>
                    <v-card-text>Are you sure you want to delete this role " {{ selectedPriviledge['title'] }} "?</v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn class="green--text darken-1" flat="flat" @click.native="deleteRole()">Yes</v-btn>
                      <v-btn class="red--text darken-1" flat="flat" @click.native="dialog = false">No</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-flex>
            </v-list-tile>
          </v-list>
          <v-card v-if="selectedPriviledge">
            <v-list v-if="selectedPriviledge" three-line subheader>
              <v-subheader>Events</v-subheader>
              <v-list-tile>
                <v-list-tile-action>
                  <v-checkbox
                    v-model="selectedPriviledge.events.create_event"
                    @click.native.stop="updateData()"
                    readonly
                  ></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Create Events</v-list-tile-title>
                  <v-list-tile-sub-title>Allow users to be able to create events</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>
              <!-- <v-subheader>Groups</v-subheader>
              <v-list-tile>
                <v-list-tile-action>
                  <v-checkbox
                    v-model="selectedPriviledge.groups.create_group"
                    @click.native.stop="updateData()"
                    readonly
                  ></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Create Group</v-list-tile-title>
                  <v-list-tile-sub-title>Allow users to be able to create groups</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-action>
                  <v-checkbox
                    v-model="selectedPriviledge.groups.post_to_group"
                    @click.native.stop="updateData()"
                    readonly
                  ></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Post to Groups</v-list-tile-title>
                  <v-list-tile-sub-title>Allow users to be able to post to groups</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-action>
                  <v-checkbox
                    v-model="selectedPriviledge.groups.create_event"
                    @click.native.stop="updateData()"
                    readonly
                  ></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Create Group Events</v-list-tile-title>
                  <v-list-tile-sub-title>Allow users to be able to create group events</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider> -->
              <v-subheader>Activity Stream</v-subheader>
              <v-list-tile>
                <v-list-tile-action>
                  <v-checkbox
                    v-model="selectedPriviledge.activity_stream.post_to_activity"
                    @click.native.stop="updateData()"
                    readonly
                  ></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Post to Activity Stream</v-list-tile-title>
                  <v-list-tile-sub-title>Allow users to be able to create post in activity stream</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>
              <v-subheader>Economic Impact</v-subheader>
              <v-list-tile>
                <v-list-tile-action>
                  <v-checkbox
                    v-model="selectedPriviledge.economic_impact.all_access"
                    @click.native.stop="giveAllAccessToEconomicImpact()"
                    readonly
                  ></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>All Access</v-list-tile-title>
                  <v-list-tile-sub-title>Give full access to the economic impact module</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile
                v-for="(analysis, index) in analysisList"
                :key="index">
                <v-list-tile-action>
                  <v-checkbox
                    v-model="selectedPriviledge.economic_impact[analysis.id]"
                    @click.native.stop="unCheckEconomicImpactAllAccess()"
                    readonly
                  ></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ analysis.text }}</v-list-tile-title>
                  <v-list-tile-sub-title>Give access to the <span style="text-transform: lowercase">{{ analysis.text }}</span></v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>
              <v-subheader>Chat</v-subheader>
              <v-list-tile href="javascript:;">
                <v-list-tile-action>
                  <v-checkbox
                    v-model="selectedPriviledge.chat.group_chat"
                    @click.native.stop="updateData()"
                    readonly
                  ></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Group Chats</v-list-tile-title>
                  <v-list-tile-sub-title>Allow users to be able to send messages in groups</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile href="javascript:;">
                <v-list-tile-action>
                  <v-checkbox @click.native.stop="updateData()"
                  v-model="selectedPriviledge.chat.private_chat"></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Private Chats</v-list-tile-title>
                  <v-list-tile-sub-title>Allow users to be able to send private messages across users</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile href="javascript:;">
                <v-list-tile-action>
                  <v-checkbox @click.native.stop="updateData()"
                  v-model="selectedPriviledge.chat.video_chat"></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Video Chats</v-list-tile-title>
                  <v-list-tile-sub-title>Enables users access to video chats</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile href="javascript:;">
                <v-list-tile-action>
                  <v-checkbox @click.native.stop="updateData()" v-model="selectedPriviledge.chat.voice_chat"></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Voice Chats</v-list-tile-title>
                  <v-list-tile-sub-title>Enables users access to voice chats</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <v-divider></v-divider>
            <v-list three-line subheader>
              <v-subheader>Email Updates</v-subheader>
              <v-list-tile href="javascript:;">
                <v-list-tile-action>
                  <v-checkbox
                    v-model="selectedPriviledge.email_updates.access"
                    @click.native.stop="updateData()"
                    readonly
                  ></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Enable Access</v-list-tile-title>
                  <v-list-tile-sub-title>Allows users to receive email updates</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile href="javascript:;">
                <v-list-tile-action>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Set limit for Email Update</v-list-tile-title>
                  <v-list-tile-sub-title>Limit the number of email updates</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-radio-group v-model="selectedPriviledge.email_updates.limit" row>
                  <v-radio @click.native.stop="updateData()" label="5" :value="5" ></v-radio>
                  <v-radio @click.native.stop="updateData()" label="10" :value="10"></v-radio>
                </v-radio-group>
              </v-list-tile>
            </v-list>
          </v-card>
          <div class="pa-4" v-if="!selectedPriviledge">
            <v-alert color="secondary" :value="true">
              No Role has been selected, Please select role to display above
            </v-alert>
          </div>
        </v-card>
        <PageFooter />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AdminSideBarMenu from './Components/AdminSideBar.vue'
import PageFooter from './Components/PageFooter.vue'
import NewRole from './Priviledges/NewRole.vue'

export default {
  components: {
    AdminSideBarMenu,
    PageFooter,
    NewRole
  },
  computed: {
    user () {
      return this.$store.getters.getUserDetails
    },
    styles () {
      return this.$store.getters.getStyles
    },
    all_priviledges () {
      const raw = this.$store.getters.getAllPriviledges
      const notAllowed = ['Client Admin', 'Business Admin', 'Staff', 'User', 'Disabled']
      this.length = Object.keys(raw).length + 1
      const filtered = Object.keys(raw)
      .filter(key => !notAllowed.includes(raw[key].title))
        .reduce((obj, key) => {
          obj[key] = raw[key]
          return obj
        }, {})
      return filtered
    },
    loading () {
      return this.$store.getters.getLoading
    },
    error () {
      return this.$store.getters.getError
    },
    selectedPriviledge () {
      if (this.currentRole) {
        return this.all_priviledges[this.currentRole]
      }
      return null
    },
    roles () {
      const allRoles = []
      const levels = Object.keys(this.all_priviledges)
      levels.forEach((role) => {
        const data = {}
        data['text'] = this.all_priviledges[role]['title']
        data['value'] = role
        allRoles.push(data)
      })
      return allRoles
    },
    screenWidth () {
      return this.$vuetify.breakpoint.width
    }
  },
  methods: {
    updateData () {
      const payload = {
        level: this.currentRole,
        priviledges: this.all_priviledges[this.currentRole]
      }
      this.$store.dispatch('updatePriviledge', payload)
    },
    giveAllAccessToEconomicImpact () {
      for (var analysis of this.analysisList) {
        this.selectedPriviledge.economic_impact[analysis.id] = this.selectedPriviledge.economic_impact.all_access
      }
      this.selectedPriviledge.economic_impact.has_access = this.selectedPriviledge.economic_impact.all_access
      this.updateData()
    },
    unCheckEconomicImpactAllAccess (val) {
      let hasTrueValues = false
      this.selectedPriviledge.economic_impact.all_access = false
      for (var value in this.selectedPriviledge.economic_impact) {
        if (this.selectedPriviledge.economic_impact[value] && value !== 'has_access') {
          hasTrueValues = true
        }
      }
      this.selectedPriviledge.economic_impact.has_access = hasTrueValues
      this.updateData()
    },
    deleteRole () {
      const payload = {
        title: this.currentRole
      }
      this.$store.dispatch('deleteRole', payload)
      this.currentRole = 0
      this.dialog = false
    },
    activeDialog () {
      this.open_modal = !this.open_modal
    }
  },
  data: () => ({
    currentRole: 0,
    length: 0,
    open_modal: false,
    dialog: false,
    limits: [
      {
        text: '5',
        value: 5
      },
      {
        text: '10',
        value: 10
      }
    ],
    analysisList: [
      {
        text: 'Spending Analysis by Geography',
        id: 'spending-analysis-by-geography',
        html: `<div class='tableauPlaceholder' style='width: 1000px; height: 3050px;'><object class='tableauViz' width='1000' height='3050' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;GeorgiaDoD_Geography' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>`,
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/GeorgiaDoD_Geography?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      },
      {
        text: 'DoD Contract Trends',
        id: 'dod-contract-trends',
        html: `<div class='tableauPlaceholder' style='width: 1000px; height: 1550px;'><object class='tableauViz' width='1000' height='1550' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;DoDContractTrends' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>`,
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/DoDContractTrends?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      },
      {
        text: 'Military Installations',
        id: 'military-installations',
        html: `<div class='tableauPlaceholder' style='width: 1000px; height: 827px;'><object class='tableauViz' width='1000' height='827' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_MilitaryInstallations_12172018&#47;MilitaryInstallations' /><param name='tabs' value='no' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>`,
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_MilitaryInstallations_12172018/MilitaryInstallations?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      },
      {
        text: 'Prime-Sub Spending Flow',
        id: 'prime-sub-spending-flow',
        html: `<div class='tableauPlaceholder' style='width: 1000px; height: 4050px;'><object class='tableauViz' width='1000' height='4050' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;DoDPrime-SubSpendingFlow' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>`,
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/DoDPrime-SubSpendingFlow?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      },
      {
        text: 'DoD Agency Spending Flow',
        id: 'dod-agency-spending-flow',
        html: `<div class='tableauPlaceholder' style='width: 1000px; height: 4050px;'><object class='tableauViz' width='1000' height='4050' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;DoDAgencySpendingFlow' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>`,
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/DoDAgencySpendingFlow?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      },
      {
        text: 'Future Needs of the DoD',
        id: 'future-needs-of-the-dod',
        html: `<div class='tableauPlaceholder' style='width: 1000px; height: 850px;'><object class='tableauViz' width='1000' height='850' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_Part3_12172018&#47;FutureNeedsoftheDoD' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>`,
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_Part3_12172018/FutureNeedsoftheDoD?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      },
      {
        text: 'DoD Contract View',
        id: 'dod-contract-view',
        html: `<div class='tableauPlaceholder' style='width: 1000px; height: 1550px;'><object class='tableauViz' width='1000' height='1550' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;DoDContractView' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>`,
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/DoDContractView?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      },
      {
        text: 'DoD Contractor View',
        id: 'dod-contractor-view',
        html: `<div class='tableauPlaceholder' style='width: 1000px; height: 1550px;'><object class='tableauViz' width='1000' height='1550' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;DoDContractorView' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>`,
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/DoDContractorView?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      },
      {
        text: 'GDX Directory vs. Georgia DoD Contract Winners',
        id: 'gdx-directory-vs-georgia-dod-contract-winners',
        html: `<div class='tableauPlaceholder' style='width: 1000px; height: 850px;'><object class='tableauViz' width='1000' height='850' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_Part3_12172018&#47;GDXDirectoryvs_GeorgiaDoDContractWinners' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>`,
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_Part3_12172018/GDXDirectoryvs_GeorgiaDoDContractWinners?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      },
      {
        text: 'Georgia Contractor Analysis',
        id: 'georgia-contractor-analysis',
        html: `<div class='tableauPlaceholder' style='width: 1000px; height: 3050px;'><object class='tableauViz' width='1000' height='3050' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;GeorgiaDoD_Contractor' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>`,
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/GeorgiaDoD_Contractor?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      }
    ]
  }),
  mounted () {
    const payload = {
      meta: {
        'h1': 'Manage Access',
        'title': 'Manage Access',
        'description': 'Admin Settings',
        'keywords': '',
        'requiresAuth': true
      }
    }
    document.title = payload.meta.title
    this.$store.commit('setHeaderInfo', payload)
  }
}
</script>

<style lang="scss" scoped>
.title-toolbar {
  padding: 0 20px !important;
}
</style>




// WEBPACK FOOTER //
// PriviledgesView.vue?3696788c